import { Dispatch, FocusEvent, useState } from "react";
import BaseDialog, { Field } from "../modelDialogs/BaseDialog";
import { updateUserDetails } from "./account/Login/Login";
import { showToast } from "./Toasts";
import { AboHandeling } from "./Abohandeling";
import { itx } from "../translationItx/itx";
import { setSession } from "./account/auth-helper";
import LoadNewProfilePicture from "./dialogs/LoadNewProfilePicture";

export default function EditProfileDialog(props: {}) {
  const {} = props;
  const [email, setEmail] = useState<string>(getUserEmailFromLocalStorrage() || "email");
  const [name, setName] = useState<string>(getUserNameFromLocalStorrage() || "name"); // no itx
  const [companyName, setCompanyName] = useState<string>(state.settings.companyName);

  function getUserNameFromLocalStorrage(): string {
    const user = localStorage.getItem("user");
    return user != "" ? JSON.parse(user as string)?.name || "" : user;
  }
  function setUserNameInLocalStorrage(name: string) {
    let user = localStorage.getItem("user");
    if (user && user != "") {
      let userDetails = JSON.parse(user);
      userDetails["name"] = name; // no itx
      localStorage.setItem("user", JSON.stringify(userDetails));
    }
  }
  function getUserEmailFromLocalStorrage(): string {
    const user = localStorage.getItem("user");
    return user != "" ? JSON.parse(user as string)?.email || "" : user;
  }
  function setUserEmailInLocalStorrage(email: string) {
    let user = localStorage.getItem("user");
    if (user && user != "") {
      let userDetails = JSON.parse(user);
      userDetails["email"] = email;
      localStorage.setItem("user", JSON.stringify(userDetails));
    }
  }

  function handleInput(
    ev: FocusEvent<HTMLInputElement, Element>,
    value: string,
    setValue: Dispatch<string>,
    emptyForbidden?: boolean,
  ) {
    if (emptyForbidden && ev.target.value == "") {
      ev.target.value = value;
      showToast({
        text: state.translate("handleTagEdit.emptyForbidden", "leer nicht erlaubt"),
      });
    } else {
      setValue(ev.target.value);
    }
  }
  function AboButton(props: {}) {
    return (
      <button
        className="button"
        onClick={() => {
          state.navigate("/selfservice");
          // window?.open("https://estada.chargebeeportal.com", "_blank")?.focus();
          state.dialogManager.closeDialog();
        }}
      >
        {itx("handleTagEdit.editSubscription", "Abos verwalten")}
      </button>
    );
  }

  function InvoiceButton(props: {}) {
    return (
      <button
        className="button"
        onClick={() => {
          // Rechnungen werden im selben Self-Service-Portal wie die Abo-Verwaltung angezeigt.
          state.navigate("/selfservice");
          state.dialogManager.closeDialog();
        }}
      >
        {itx("editProfileDialog.downloadInvoice", "Rechnung herunterladen")}
      </button>
    );
  }

  function LogoutButton(props: {}) {
    return (
      <button
        className="button"
        onClick={() => {
          setSession(null);
          localStorage.setItem("user", "");
          state.dialogManager.closeDialog();
          state.navigate("/login");
        }}
      >
        {itx("loginPage.logout", "Ausloggen")}
      </button>
    );
  }

  return (
    <BaseDialog
      title={state.translate("menuBar.editProfile", "Edit Profile")}
      // onClose={() => {
      //     return true
      // }}

      onOk={() => {
        let changedValues: any = {};
        if (email != getUserEmailFromLocalStorrage()) {
          setUserEmailInLocalStorrage(email);
          changedValues = { new_email: email, ...changedValues };
        }
        if (name != getUserNameFromLocalStorrage()) {
          setUserNameInLocalStorrage(name);
          // redraw prof pic?
          changedValues = { name: name, ...changedValues };
        }
        if (companyName != state.settings.companyName) {
          state.settings.companyName = companyName;
          changedValues = { company_name: companyName, ...changedValues };
        }
        updateUserDetails(changedValues);
        return true;
      }}
    >
      {/* is in other Branche on edit */}
      <div style={{ textAlign: "center" }}>
        <div
          className="user-menu-img"
          style={{ display: "inline-block" }}
          onClick={() => {
            const urlNew = (document.getElementsByClassName("profP")[0] as any).src;
            state.dialogManager.pushDialog("loadNewProfilePicture", <LoadNewProfilePicture image={urlNew} />); // no itx
          }}
          data-tooltip-id="tv-tooltip"
          data-tooltip-content={state.translate("loadNewProfilePicture.changeProfilePicture", "") + "?"}
          data-tooltip-place="right" // no itx
        >
          <img
            className="user-menu-profP item-shadow"
            src={(document.getElementsByClassName("profP")[0] as any).src}
            style={{ alignSelf: "center" }}
          ></img>
          <button className="button circle editImg">
            <i className={`las la-pen`}></i>
          </button>
        </div>
        <div style={{ marginTop: "8px", fontWeight: "bold" }}>{email}</div>
      </div>
      <Field label={state.translate("register.fullName", "fullName") + ": "} labelStyle={{ paddingRight: "30px" }}>
        <input
          key="fullName"
          className="input form-input-sm input-large"
          maxLength={state.maxCharLimit.text}
          defaultValue={name}
          onBlur={(ev) => {
            handleInput(ev, name, setName, true);
          }}
        />
      </Field>
      {/* <Field label={state.translate("loginPage.email", "email") + ": "}>
        <input
          key="eMail"
          className="input form-input-sm input-large"
          maxLength={state.maxCharLimit.text}
          defaultValue={email}
          onBlur={(ev) => {
            handleInput(ev, email, setEmail, true);
          }}
        />
      </Field> */}
      <Field label={state.translate("SettingsScreen.companyName", "companyName") + ": "}>
        <input
          key="companyName"
          className="input form-input-sm input-large"
          maxLength={state.maxCharLimit.smallText}
          defaultValue={companyName}
          onBlur={(ev) => {
            handleInput(ev, companyName, setCompanyName);
          }}
        />
      </Field>
      <Field>
        <AboButton />
      </Field>
      <Field>
        <InvoiceButton />
      </Field>
      <Field>
        <LogoutButton />
      </Field>
    </BaseDialog>
  );
}
